import createVueComponent from '../createVueComponent';

const Import = createVueComponent('ImportIcon', [
  ['path', { d: 'M12 3v12' }],
  ['path', { d: 'M8 11l4 4 4-4' }],
  [
    'path',
    {
      d: 'M8 5H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2h-4',
    },
  ],
]);

export default Import;
